export default __webpack_public_path__ + "static/media/cert-congrats-icon.380b4d21.png";